module.exports = __webpack_public_path__ + "media/images/instagram-ea1bb834115f1cab447be219b0f21e4a.svg";